import React, { useEffect, useState } from 'react'
import './OrderDetail.css'
import { useParams } from 'react-router-dom'
// redux
import { useDispatch, useSelector } from 'react-redux'
import {
  forceCancelOrder,
  getGoogleAnalytics,
  getOrderDetail,
  getOrderDetailContact,
  updateOrderStatus,
} from '../../features/order/orderSlice'
// Utils
import Modal from 'react-modal'
import { FaTimes } from 'react-icons/fa'
import { toast } from 'react-toastify'
import OrderInformation from '../../components/order/detail/OrderInformation'
import DistributionInformation from '../../components/order/detail/DistributionInformation'
import ProgressStatus from '../../components/order/detail/ProgressStatus'
import PrintStatus from '../../components/order/detail/PrintStatus'
import DistibutionArea from '../../components/order/detail/DistibutionArea'
import SalesStore from '../../components/order/detail/SalesStore'
import SpinnerComp from '../../components/util/SpinnerComp'
import { setToken } from '../../features/auth/authSlice'

const OrderDetail = () => {
  // Params
  const { orderId } = useParams()

  //   Dispatching to get Order Detail
  const { token, distribution_status } = useSelector((state) => state.auth)
  const data = {
    order_key: orderId,
  }

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getOrderDetail({ data, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        const data = {
          user_id: res?.data?.value?.user_id,
          cart_system_id: res?.data?.value?.cart_system_id,
        }
        dispatch(getOrderDetailContact({ data, token }))
          .unwrap()
          .then(({ res, newToken }) => {
            if (res.data && res.data.result === 'success' && newToken) {
              dispatch(setToken(newToken))
            }
          })
          .catch((error) => {})
        if (res.data && res.data.result === 'success' && newToken) {
          dispatch(setToken(newToken))
        }
      })
      .catch((error) => {})
    // eslint-disable-next-line
  }, [orderId]);

  // Displaying order status
  const { orderLoading, order_detail } = useSelector((state) => state.order)
  const dataDetail = order_detail?.value
  const distributionStatus = distribution_status?.value.status_list
  const printingStatus = distribution_status?.value.printing_status_list
  // Modal Change Status
  Modal.setAppElement('#root')
  const [currentStatus, setCurrentStatus] = useState(null)
  const [targetStatus, setTargetStatus] = useState(null)
  const [targetStatusId, setTargetStatusId] = useState(null)
  const [modalStepIsOpen, setModalStepIsOpen] = useState(false)
  const [modalCancelIsOpen, setModalCancelIsOpen] = useState(false)
  const [modalForcedCancelIsOpen, setModalForcedCancelIsOpen] = useState(false)
  const [modalNGIsOpen, setModalNGIsOpen] = useState(false)
  const [modalNGNewIsOpen, setModalNGNewIsOpen] = useState(false)
  const [reasonText, setReasonText] = useState('')
  const toggleModalSteps = () => {
    setModalStepIsOpen((prev) => !prev)
  }
  const toggleModalCancel = () => {
    setModalCancelIsOpen((prev) => !prev)
  }
  const toggleModalForcedCancel = () => {
    setModalForcedCancelIsOpen((prev) => !prev)
  }
  const toggleModalNG = () => {
    setModalNGIsOpen((prev) => !prev)
  }
  const toggleModalNGNew = () => {
    setModalNGNewIsOpen((prev) => !prev)
  }

  const statusOnClick = (dataDetail, idx) => {
    if (
      dataDetail.status === 6 ||
      dataDetail.status === 7 ||
      dataDetail.status === 8
    ) {
      return
    }
    setCurrentStatus(distributionStatus[dataDetail.status])
    setTargetStatus(distributionStatus[idx])
    setTargetStatusId(idx)
    toggleModalSteps()
    // if (dataDetail.status === idx) alert('udah sama')
  }

  // printing
  const [currentStatusPrinting, setCurrentStatusPrinting] = useState(null)
  const [targetStatusPrinting, setTargetStatusPrinting] = useState(null)
  const [targetStatusIdPrinting, setTargetStatusIdPrinting] = useState(null)
  const [modalStepIsOpenPrinting, setModalStepIsOpenPrinting] = useState(false)
  const [modalCancelIsOpenPrinting, setModalCancelIsOpenPrinting] =
    useState(false)
  const [modalNGIsOpenPrinting, setModalNGIsOpenPrinting] = useState(false)
  const [modalNGNewIsOpenPrinting, setModalNGNewIsOpenPrinting] =
    useState(false)
  const [reasonTextPrinting, setReasonTextPrinting] = useState('')
  const toggleModalStepsPrinting = () => {
    setModalStepIsOpenPrinting((prev) => !prev)
  }
  const toggleModalCancelPrinting = () => {
    setModalCancelIsOpenPrinting((prev) => !prev)
  }
  const toggleModalNGPrinting = () => {
    setModalNGIsOpenPrinting((prev) => !prev)
  }
  const toggleModalNGNewPrinting = () => {
    setModalNGNewIsOpenPrinting((prev) => !prev)
  }
  const printStatusOnClick = (dataDetail, idx) => {
    if (
      dataDetail.printing_status === 6 ||
      dataDetail.printing_status === 7 ||
      dataDetail.printing_status === 8
    ) {
      return
    }
    setCurrentStatusPrinting(printingStatus[dataDetail.printing_status])
    setTargetStatusPrinting(printingStatus[idx])
    setTargetStatusIdPrinting(idx)
    toggleModalStepsPrinting()
    // if (dataDetail.status === idx) alert('udah sama')
  }

  const statusChangeOnSubmit = (e) => {
    e.preventDefault()
    const dataStatusChange = {
      order_key: orderId,
      status: targetStatusId,
      status_name: 'posting',
    }
    dispatch(updateOrderStatus({ dataStatusChange, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res && res.data.result === 'success') {
          dispatch(getOrderDetail({ data, token }))
          toast.success('注文ステータスが更新されました')
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        }
      })
      .catch((error) => {
        if (error.description === 'error updating order status') {
          if (
            error?.error_message ===
            'Order is not ready to be updated to status 2. Check the following: destination_fixed: 0, '
          ) {
            toast.error(
              'ステータス 2 に更新できません。お手数ですが、配送先住所を設定してください。'
            )
          } else {
            toast.error(
              'ステータスを２に更新できません。アト基幹DB連携データを作成してください。'
            )
          }
        }
      })

    toggleModalSteps()
  }

  const statusChangeOnSubmitPrinting = (e) => {
    e.preventDefault()
    const dataStatusChange = {
      order_key: orderId,
      status: targetStatusIdPrinting,
      status_name: 'printing',
    }
    dispatch(updateOrderStatus({ dataStatusChange, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res && res.data.result === 'success') {
          dispatch(getOrderDetail({ data, token }))
          toast.success('注文ステータスが更新されました')
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        }
      })
      .catch((error) => {
        if (error.description === 'error updating order status') {
          if (
            error?.error_message ===
            'Order is not ready to be updated to status 2. Check the following: destination_fixed: 0, '
          ) {
            toast.error(
              'ステータス 2 に更新できません。お手数ですが、配送先住所を設定してください。'
            )
          } else {
            toast.error(
              'ステータスを２に更新できません。アト基幹DB連携データを作成してください。'
            )
          }
        }
      })

    toggleModalStepsPrinting()
  }

  const reviewApprovalNGHandlerNew = (e) => {
    e.preventDefault()
    const dataStatusChange = {
      order_key: orderId,
      status: 6,
      cancelation_reason: reasonText,
      status_name: 'posting',
    }
    dispatch(updateOrderStatus({ dataStatusChange, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res && res.data.result === 'success') {
          dispatch(getOrderDetail({ data, token }))
          toast.success('注文を承認NGに変更しました')
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        }
      })
      .catch((error) => {})
    toggleModalNGNew()
  }

  const reviewApprovalNGHandler = (e) => {
    e.preventDefault()
    const dataStatusChange = {
      order_key: orderId,
      status: 5,
      status_name: 'posting',
    }
    dispatch(updateOrderStatus({ dataStatusChange, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res && res.data.result === 'success') {
          dispatch(getOrderDetail({ data, token }))
          toast.success('注文を承認NGに変更しました')
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        }
      })
      .catch((error) => {})
    toggleModalNG()
  }

  const cancelHandler = (e) => {
    e.preventDefault()
    const dataStatusChange = {
      order_key: orderId,
      status: 7,
      status_name: 'posting',
    }
    dispatch(updateOrderStatus({ dataStatusChange, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res && res.data.result === 'success') {
          dispatch(getOrderDetail({ data, token }))
          toast.success('注文がキャンセルされました')
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        }
      })
      .catch((error) => {})

    toggleModalCancel()
  }

  const forcedCancelHandler = (e) => {
    e.preventDefault()
    const dataStatusChange = {
      order_key: orderId,
    }
    // console.log('hehe', dataStatusChange)
    dispatch(forceCancelOrder({ dataStatusChange, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res && res.data.result === 'success') {
          dispatch(getOrderDetail({ data, token }))
          toast.success('その注文は強制的にキャンセルされました。')
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        }
      })
      .catch((error) => {})

    toggleModalForcedCancel()
  }

  // printing
  const reviewApprovalNGHandlerNewPrinting = (e) => {
    e.preventDefault()
    const dataStatusChange = {
      order_key: orderId,
      status: 6,
      cancelation_reason: reasonTextPrinting,
      status_name: 'printing',
    }
    dispatch(updateOrderStatus({ dataStatusChange, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res && res.data.result === 'success') {
          dispatch(getOrderDetail({ data, token }))
          toast.success('注文を承認NGに変更しました')
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        }
      })
      .catch((error) => {})
    toggleModalNGNewPrinting()
  }

  const reviewApprovalNGHandlerPrinting = (e) => {
    e.preventDefault()
    const dataStatusChange = {
      order_key: orderId,
      status: 5,
      status_name: 'printing',
    }
    dispatch(updateOrderStatus({ dataStatusChange, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res && res.data.result === 'success') {
          dispatch(getOrderDetail({ data, token }))
          toast.success('注文を承認NGに変更しました')
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        }
      })
      .catch((error) => {})
    toggleModalNGPrinting()
  }

  const cancelHandlerPrinting = (e) => {
    e.preventDefault()
    const dataStatusChange = {
      order_key: orderId,
      status: 7,
      status_name: 'printing',
    }
    dispatch(updateOrderStatus({ dataStatusChange, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res && res.data.result === 'success') {
          dispatch(getOrderDetail({ data, token }))
          toast.success('注文がキャンセルされました')
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        }
      })
      .catch((error) => {})

    toggleModalCancelPrinting()
  }

  if (orderLoading) return <SpinnerComp />

  if (order_detail?.result === 'failure') {
    return (
      <div className="w-full text-center mt-16">
        <h2 className="mb-8 font-bold text-6xl text-gray-600">
          <span className="sr-only">Error</span>404
        </h2>
        <p className="text-2xl font-semibold md:text-2xl">
          Sorry, we couldn't find this page.
        </p>
      </div>
    )
  }

  return (
    <div className="w-full text-gray-700 mb-8 px-2">
      {order_detail && !orderLoading && order_detail?.result !== 'failure' && (
        <>
          <h1 className="text-center my-4 text-2xl leading-snug uppercase">
            注文情報詳細
          </h1>

          <div className="w-full sm:w-[80%] sm:min-w-[600px] mx-auto">
            <div className="w-full flex gap-4 bg-blue-600 mt-8 mb-2 text-lg text-white font-semibold p-2">
              <h1 className="bg-blue-600 text-lg text-white font-semibold">
                注文番号 : {orderId}
              </h1>
              <p>商品ID : {dataDetail?.extra?.sync?.product_id}</p>
            </div>

            {/* Order Information */}
            <OrderInformation
              dataDetail={dataDetail}
              distributionStatus={distributionStatus}
            />
            {/* End Order Information */}

            {/* Progress Printing Status Bar */}
            {dataDetail?.data_type === 'orikomi_print' && (
              <h1 className="text-md text-center font-semibold mt-12">
                印刷ステイタス
              </h1>
            )}
            {dataDetail?.data_type === 'orikomi_print' && (
              <PrintStatus
                modalStepIsOpenPrinting={modalStepIsOpenPrinting}
                toggleModalStepsPrinting={toggleModalStepsPrinting}
                customStyles={customStyles}
                dataDetail={dataDetail}
                printingStatus={printingStatus}
                printStatusOnClick={printStatusOnClick}
                targetStatusPrinting={targetStatusPrinting}
                statusChangeOnSubmitPrinting={statusChangeOnSubmitPrinting}
                currentStatusPrinting={currentStatusPrinting}
              />
            )}
            {/* End Progress Printing Status Bar */}

            {/* Button Progress Confirm */}
            {dataDetail?.data_type === 'orikomi_print' && (
              <div className="flex w-full justify-end gap-2 mb-12">
                <button
                  onClick={toggleModalNGNewPrinting}
                  disabled={
                    dataDetail.printing_status === 6 ||
                    dataDetail.printing_status === 5 ||
                    dataDetail.printing_status === 7
                  }
                  className="px-4  py-2 disabled:bg-[#c4c4c4] bg-blue-600 text-white"
                >
                  {printingStatus?.map((status, idx) => idx === 6 && status)}
                </button>
                <button
                  onClick={toggleModalNGPrinting}
                  disabled={
                    dataDetail.printing_status === 6 ||
                    dataDetail.printing_status === 5 ||
                    dataDetail.printing_status === 7
                  }
                  className="px-4  py-2 disabled:bg-[#c4c4c4] bg-blue-600 text-white"
                >
                  {printingStatus?.map((status, idx) => idx === 5 && status)}
                </button>
                <button
                  onClick={toggleModalCancelPrinting}
                  disabled={
                    dataDetail.printing_status === 6 ||
                    dataDetail.printing_status === 5 ||
                    dataDetail.printing_status === 7
                  }
                  className="px-4 py-2 disabled:bg-[#c4c4c4] bg-slate-600 text-white"
                >
                  {printingStatus?.map((status, idx) => idx === 7 && status)}
                </button>
              </div>
            )}
            {/* Modal NG Confir Printingm */}
            <Modal
              isOpen={modalNGNewIsOpenPrinting}
              onRequestClose={toggleModalNGNewPrinting}
              style={customStyles}
              contentLabel="Change Status to NG"
            >
              <button
                className="float-right rounded-full text-black text-xl"
                onClick={toggleModalNGNewPrinting}
              >
                <FaTimes />
              </button>
              <h2 className="text-left px-2 text-md sm:text-xl font-semibold mb-8">
                原稿フォーマットNG 理由
              </h2>
              <form
                onSubmit={reviewApprovalNGHandlerNewPrinting}
                className="p-2 flex flex-col"
              >
                <div className="flex flex-col justify-end gap-2">
                  <div className="w-full w-12/12 flex flex-col justify-between">
                    <p>原稿フォーマットNG 理由</p>
                    <textarea
                      className="bg-[#EBEBEB] mt-2 h-max p-1"
                      name=""
                      rows="4"
                      id=""
                      onChange={(e) => {
                        setReasonTextPrinting(e.target.value)
                      }}
                    ></textarea>
                  </div>

                  <div className="flex justify-end gap-2">
                    <button
                      className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                      type="submit"
                    >
                      確定する
                    </button>

                    <button
                      onClick={toggleModalNGNewPrinting}
                      className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                      type="button"
                    >
                      キャンセル
                    </button>
                  </div>
                </div>
              </form>
            </Modal>
            {/* End Modal NG Confirm Printing */}
            {/* Modal NG Confirm Printing */}
            <Modal
              isOpen={modalNGIsOpenPrinting}
              onRequestClose={toggleModalNGPrinting}
              style={customStyles}
              contentLabel="Change Status to NG"
            >
              <button
                className="float-right rounded-full text-black text-xl"
                onClick={toggleModalNGPrinting}
              >
                <FaTimes />
              </button>
              <h2 className="text-left px-2 text-md sm:text-xl font-semibold mb-8">
                印刷ステイタス「到着済」設定の確認
              </h2>
              <form
                onSubmit={reviewApprovalNGHandlerPrinting}
                className="p-2 flex flex-col"
              >
                <div className="flex flex-col justify-end gap-2">
                  <div className="w-full w-12/12 flex flex-col justify-between">
                    <p>印刷ステイタスを到着済に設定してよろしいですか？</p>
                  </div>

                  <div className="flex justify-end gap-2">
                    <button
                      className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                      type="submit"
                    >
                      確定する
                    </button>

                    <button
                      onClick={toggleModalNGPrinting}
                      className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                      type="button"
                    >
                      キャンセル
                    </button>
                  </div>
                </div>
              </form>
            </Modal>
            {/* End Modal NG Confirm Printing */}
            {/* Modal Cancel Confirm Printing */}
            <Modal
              isOpen={modalCancelIsOpenPrinting}
              onRequestClose={toggleModalCancelPrinting}
              style={customStyles}
              contentLabel="Change Status to Cancel"
            >
              <button
                className="float-right rounded-full text-black text-xl"
                onClick={toggleModalCancelPrinting}
              >
                <FaTimes />
              </button>
              <h2 className="text-left px-2 text-md sm:text-xl font-semibold mb-8">
                注文のキャンセルの確認
              </h2>
              <form
                onSubmit={cancelHandlerPrinting}
                className="p-2 flex flex-col"
              >
                <div className="flex flex-col justify-end gap-2">
                  <div className="w-full w-12/12 flex flex-col justify-between">
                    <p>注文をキャンセルに変更してよろしいですか？</p>
                  </div>

                  <div className="flex justify-end gap-2">
                    <button
                      className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                      type="submit"
                    >
                      確定する
                    </button>

                    <button
                      onClick={toggleModalCancelPrinting}
                      className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                      type="button"
                    >
                      キャンセル
                    </button>
                  </div>
                </div>
              </form>
            </Modal>
            {/* End Modal Cancel Confirm Printing */}
            {/* End Button Progress Confirm Printing */}

            {/* Progress Status Bar */}
            <h1 className="text-md text-center font-semibold mt-12">
              配布ステータス
            </h1>
            <ProgressStatus
              modalStepIsOpen={modalStepIsOpen}
              toggleModalSteps={toggleModalSteps}
              customStyles={customStyles}
              dataDetail={dataDetail}
              distributionStatus={distributionStatus}
              statusOnClick={statusOnClick}
              targetStatus={targetStatus}
              statusChangeOnSubmit={statusChangeOnSubmit}
              currentStatus={currentStatus}
            />
            {/* End Progress Status Bar */}

            {/* Button Progress Confirm */}
            <div className="flex w-full justify-end gap-2 mb-12">
              <button
                onClick={toggleModalNGNew}
                disabled={
                  dataDetail.status === 6 ||
                  dataDetail.status === 5 ||
                  dataDetail.status === 7
                }
                className="px-4  py-2 disabled:bg-[#c4c4c4] bg-blue-600 text-white"
              >
                {distributionStatus?.map((status, idx) => idx === 6 && status)}
              </button>
              <button
                onClick={toggleModalNG}
                disabled={
                  dataDetail.status === 6 ||
                  dataDetail.status === 5 ||
                  dataDetail.status === 7
                }
                className="px-4  py-2 disabled:bg-[#c4c4c4] bg-blue-600 text-white"
              >
                {distributionStatus?.map((status, idx) => idx === 5 && status)}
              </button>
              <button
                onClick={toggleModalCancel}
                disabled={
                  dataDetail.status === 6 ||
                  dataDetail.status === 5 ||
                  dataDetail.status === 7
                }
                className="px-4 py-2 disabled:bg-[#c4c4c4] bg-slate-600 text-white"
              >
                {distributionStatus?.map((status, idx) => idx === 7 && status)}
              </button>
              <button
                onClick={toggleModalForcedCancel}
                disabled={dataDetail?.estimation?.extra?.sync?.product_id === 0}
                className="px-4 py-2 disabled:bg-[#c4c4c4] bg-red-700 text-white"
              >
                {distributionStatus?.map((status, idx) => idx === 8 && status)}
              </button>
            </div>
            {/* Modal NG Confirm */}
            <Modal
              isOpen={modalNGNewIsOpen}
              onRequestClose={toggleModalNGNew}
              style={customStyles}
              contentLabel="Change Status to NG"
            >
              <button
                className="float-right rounded-full text-black text-xl"
                onClick={toggleModalNGNew}
              >
                <FaTimes />
              </button>
              <h2 className="text-left px-2 text-md sm:text-xl font-semibold mb-8">
                原稿フォーマットNG 理由
              </h2>
              <form
                onSubmit={reviewApprovalNGHandlerNew}
                className="p-2 flex flex-col"
              >
                <div className="flex flex-col justify-end gap-2">
                  <div className="w-full w-12/12 flex flex-col justify-between">
                    <p>原稿フォーマットNG 理由</p>
                    <textarea
                      className="bg-[#EBEBEB] mt-2 h-max p-1"
                      name=""
                      rows="4"
                      id=""
                      onChange={(e) => {
                        setReasonText(e.target.value)
                      }}
                    ></textarea>
                  </div>

                  <div className="flex justify-end gap-2">
                    <button
                      className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                      type="submit"
                    >
                      確定する
                    </button>

                    <button
                      onClick={toggleModalNGNew}
                      className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                      type="button"
                    >
                      キャンセル
                    </button>
                  </div>
                </div>
              </form>
            </Modal>
            {/* End Modal NG Confirm */}
            {/* Modal NG Confirm */}
            <Modal
              isOpen={modalNGIsOpen}
              onRequestClose={toggleModalNG}
              style={customStyles}
              contentLabel="Change Status to NG"
            >
              <button
                className="float-right rounded-full text-black text-xl"
                onClick={toggleModalNG}
              >
                <FaTimes />
              </button>
              <h2 className="text-left px-2 text-md sm:text-xl font-semibold mb-8">
                印刷ステイタス「承認NG」設定の確認
              </h2>
              <form
                onSubmit={reviewApprovalNGHandler}
                className="p-2 flex flex-col"
              >
                <div className="flex flex-col justify-end gap-2">
                  <div className="w-full w-12/12 flex flex-col justify-between">
                    <p>印刷ステイタスを承認NGに設定してよろしいですか？</p>
                  </div>

                  <div className="flex justify-end gap-2">
                    <button
                      className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                      type="submit"
                    >
                      確定する
                    </button>

                    <button
                      onClick={toggleModalNG}
                      className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                      type="button"
                    >
                      キャンセル
                    </button>
                  </div>
                </div>
              </form>
            </Modal>
            {/* End Modal NG Confirm */}
            {/* Modal Cancel Confirm */}
            <Modal
              isOpen={modalCancelIsOpen}
              onRequestClose={toggleModalCancel}
              style={customStyles}
              contentLabel="Change Status to Cancel"
            >
              <button
                className="float-right rounded-full text-black text-xl"
                onClick={toggleModalCancel}
              >
                <FaTimes />
              </button>
              <h2 className="text-left px-2 text-md sm:text-xl font-semibold mb-8">
                注文のキャンセルの確認
              </h2>
              <form onSubmit={cancelHandler} className="p-2 flex flex-col">
                <div className="flex flex-col justify-end gap-2">
                  <div className="w-full w-12/12 flex flex-col justify-between">
                    <p>注文をキャンセルに変更してよろしいですか？</p>
                  </div>

                  <div className="flex justify-end gap-2">
                    <button
                      className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                      type="submit"
                    >
                      確定する
                    </button>

                    <button
                      onClick={toggleModalCancel}
                      className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                      type="button"
                    >
                      キャンセル
                    </button>
                  </div>
                </div>
              </form>
            </Modal>
            {/* End Modal Cancel Confirm */}
            {/* Modal FORCED Cancel Confirm */}
            <Modal
              isOpen={modalForcedCancelIsOpen}
              onRequestClose={toggleModalForcedCancel}
              style={customStyles}
              contentLabel="Change Status to Cancel"
            >
              <button
                className="float-right rounded-full text-black text-xl"
                onClick={toggleModalForcedCancel}
              >
                <FaTimes />
              </button>
              <h2 className="text-left px-2 text-md sm:text-xl font-semibold mb-8">
                注文のキャンセルの確認
              </h2>
              <form
                onSubmit={forcedCancelHandler}
                className="p-2 flex flex-col"
              >
                <div className="flex flex-col justify-end gap-2">
                  <div className="w-full w-12/12 flex flex-col justify-between">
                    {dataDetail?.extra?.sync?.product_id === 0 ? (
                      <p className="font-semibold text-red-500">
                        データがコアDBに送信された後にのみ、強制キャンセルが可能です。
                      </p>
                    ) : (
                      <p className="font-semibold text-red-500">
                        これを強制的にキャンセルする場合、ダッシュボードから支払いもキャンセルする必要があるかもしれません。
                      </p>
                    )}
                  </div>

                  <div className="flex justify-end gap-2">
                    {dataDetail?.extra?.sync?.product_id !== 0 ? (
                      <button
                        className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                        type="submit"
                        disabled={dataDetail?.extra?.sync?.product_id === 0}
                      >
                        確定する
                      </button>
                    ) : null}

                    <button
                      onClick={toggleModalForcedCancel}
                      className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                      type="button"
                    >
                      キャンセル
                    </button>
                  </div>
                </div>
              </form>
            </Modal>
            {/* End Modal FORCED Cancel Confirm */}
            {/* End Button Progress Confirm */}

            {/* Order Information */}
            <h1 className="text-md font-semibold my-4">案件詳細</h1>
            <DistributionInformation dataDetail={dataDetail} token={token} />
            {/* End Order Information */}

            {/* Sales Store */}
            <SalesStore dataDetail={dataDetail} token={token} />
            {/* EndSales Store */}

            {/* Distribution Area */}
            {dataDetail && (
              <DistibutionArea
                token={token}
                customStyles={customStyles}
                dataDetail={dataDetail}
              />
            )}
            {/* End Distribution Area */}
          </div>
        </>
      )}
    </div>
  )
}

const customStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    zIndex: 1000,
  },
  content: {
    maxHeight: '80vh',
    width: '80%',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    position: 'relative',
    border: '1px solid black',
    background: '#fff',
  },
}

export default OrderDetail
